import React from 'react';
import styled from 'styled-components';

/* eslint-disable react/prop-types */
var RemovablePillWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1qoa267-0"
})(["display:flex;align-items:center;outline:none;height:", ";max-width:90%;margin:0;padding:0 4px;background-color:", ";border-top-left-radius:", ";border-bottom-left-radius:", ";& + div{border-top-right-radius:", ";border-bottom-right-radius:", ";}"], function (props) {
  return props.theme.space.xs;
}, function (props) {
  return props.theme.colors.brand[200];
}, function (props) {
  return props.theme.fontSizes[4];
}, function (props) {
  return props.theme.fontSizes[4];
}, function (props) {
  return props.theme.fontSizes[4];
}, function (props) {
  return props.theme.fontSizes[4];
});
var PillLabel = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-1qoa267-1"
})(["margin:0 4px;color:", ";white-space:nowrap;text-overflow:ellipsis;overflow:hidden;"], function (props) {
  return props.theme.colors.neutral[800];
});

var RemovablePill = function RemovablePill(_ref) {
  var label = _ref.label,
      clear = _ref.clear;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RemovablePillWrapper, {
    "data-testid": "pill-wrapper"
  }, /*#__PURE__*/React.createElement(PillLabel, null, label)), clear);
};

var MultiValueLabel = function MultiValueLabel(_ref2) {
  var children = _ref2.children,
      clear = _ref2.clear;
  return /*#__PURE__*/React.createElement(RemovablePill, {
    label: children,
    clear: clear
  });
};

export { MultiValueLabel };
//# sourceMappingURL=MultiValueLabel.js.map
